import { Typography, Box, useTheme } from "@mui/material";

type Props = {
  title: string;
  subtitle: string;
};

const Header: React.FC<Props> = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = theme.palette;

  return (
    <Box mb="30px">
      <Typography
        variant="h2"
        color={colors.grey[100]}
        fontWeight="bold"
        sx={{ mb: "5px" }}
      >
        {title}
      </Typography>

      <Typography variant="h5" color={colors.blueAccent[600]}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
